"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Documents = void 0;
var React = _interopRequireWildcard(require("react"));
var _uiKit = require("@cian/ui-kit");
var _Document = require("../Document");
var _DocumentGroup = require("../DocumentGroup");
var styles = _interopRequireWildcard(require("./Documents.css"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const Documents = _ref => {
  let {
    documents,
    documentsCount,
    documentsCountHasWarning
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    className: styles['documents']
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['title']
  }, /*#__PURE__*/React.createElement(_uiKit.UIHeading4, null, "\u0414\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u044B \u043A\u043E\u0440\u043F\u0443\u0441\u0430"), /*#__PURE__*/React.createElement("div", {
    className: styles['subtitle']
  }, /*#__PURE__*/React.createElement(_uiKit.UIText2, {
    color: documentsCountHasWarning ? 'text-warning-default' : 'gray40_100'
  }, documentsCount))), documents.map((document, index) => {
    if (document.type === 'pdf') {
      return /*#__PURE__*/React.createElement(_Document.Document, {
        key: index,
        title: document.title,
        subtitle: document.subtitle,
        link: document.url,
        isActual: document.isActual
      });
    }
    if (document.type === 'set' && document.subdocuments) {
      return /*#__PURE__*/React.createElement(_DocumentGroup.DocumentGroupToggle, {
        key: index,
        title: document.title,
        documents: document.subdocuments.map(subdocument => /*#__PURE__*/React.createElement(_Document.Document, {
          key: subdocument.url,
          title: subdocument.title,
          link: subdocument.url
        }))
      });
    }
    return null;
  }));
};
exports.Documents = Documents;